module.exports = __webpack_public_path__ + "static/media/incomplete_icon.3d001e83.svg";